module.exports = __webpack_public_path__ + "resources/img/img_text_to_speech2_jp.9f8c2e43eeb52fd6e4dea1bb7f171db8.png";